import React from "react";
import "./home.css";
import ProfilePic from "./images/profile_pic.jpg";
import NavBar from "./components/NavBar.js";
import "../utilities.css";
import Parallax from "react-rellax";

export default function Home() {
  return (
    <body>
      <NavBar active="home" />
      <div className="body">
        <div>
          <h1 className="name">About Me</h1>
          <Parallax speed={10}>
            <p className="bio">
              Hi! I'm a senior at MIT majoring in Computer Science and
              Engineering. I'm passionate about using technology to create
              applications and programs that facilitate people's lives, from
              motion sensors using microcontrollers to a social media travel
              photobook web app that displays posts on a map.
            </p>
          </Parallax>
          <img className="profilePic" src={ProfilePic} />
        </div>
        <div>
          <h2>Projects Video Portfolio</h2>
          <iframe
            className="portfolioVid"
            src="https://www.youtube.com/embed/bYdiokr0fBw"
          ></iframe>
        </div>
      </div>
    </body>
  );
}
